// Cart AJAX API Implementation
document.addEventListener('DOMContentLoaded', function() {
  // Initialize cart functionality
  initCartFunctionality();
  
  // Add event listeners to "Add to cart" buttons in new-products-box section
  initAddToCartButtons();
  initAddToCartButtonsProduct();
  
  // Initialize gift buttons state if they exist
  if (document.querySelector('.add-gift-btn')) {
    updateGiftButtons();
  }
  
  // Initialize gift 2 buttons state if they exist
  if (document.querySelector('.add-gift-btn-2')) {
    updateGiftButtons2();
  }
  
  // Animate progress bar on initial page load
  animateProgressBarOnLoad();
});

// Function to animate progress bar on initial page load
function animateProgressBarOnLoad() {
  setTimeout(()=>{
  const progressBarFill = document.querySelector('.progress-line-fill');
  if (progressBarFill && progressBarFill.hasAttribute('data-progress-percentage')) {
    const targetPercentage = progressBarFill.getAttribute('data-progress-percentage');
    
    // Check if targetPercentage is valid
    if (targetPercentage && targetPercentage !== '0') {
      // Start from 0
      progressBarFill.style.width = '0%';
      
      // Force a reflow
      progressBarFill.offsetHeight;
      
      // Animate to target percentage
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          progressBarFill.style.width = targetPercentage + '%';
        });
      });
    }
  }
  }, 300)
}

// Free Gift Functions
function addFreeGift(button) {
  const productId = button.getAttribute('data-product-id');
  const variantId = button.getAttribute('data-variant-id');

  // Check if we've reached the maximum free gifts
  const maxFreeGifts = parseInt(document.getElementById('max-free-gifts') ? document.getElementById('max-free-gifts').value : 1);
  const currentFreeGifts = countFreeGiftsInCart();
  
  if (currentFreeGifts >= maxFreeGifts) {
    button.disabled = true;
    button.textContent = 'Limit reached';
    return;
  }
  
  // Disable the button to prevent multiple clicks
  button.disabled = true;
  button.textContent = 'Adding...';
  
  // Add the free gift to cart with price 0
  fetch('/cart/add.js', {         
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
      properties: {
        '_free_gift': 'true'
      }
    })
  })
  .then(response => response.json())
  .then(data => {
    // Update button text
    button.textContent = 'Added!';
    
    // Get the free gift section
    const freeGiftSlider = document.querySelector('.free-gift-slider');
    
      // Play confetti animation
      if (window.cartConfetti) {
  
        
        window.cartConfetti.play();
        
        // Update cart immediately - don't wait for animation to complete
        setTimeout(()=>{
        updateCart();
              // Hide the free gift section when gift is added to cart
              if (freeGiftSlider) {
                freeGiftSlider.style.display = 'none';
              }
      }, 1400)
      }
  })
  .catch(error => {
    console.error('Error:', error);
    button.disabled = false;
    const addGiftText = document.getElementById('add-gift-text') ? document.getElementById('add-gift-text').value : 'Add to cart';
    button.textContent = addGiftText;
  });
}

// Free Gift 2 Functions
function addFreeGift2(button) {
  const productId = button.getAttribute('data-product-id');
  const variantId = button.getAttribute('data-variant-id');

  // Check if we've reached the maximum free gifts 2
  // We'll need to count only _free_gift_2 items
  const currentFreeGifts2 = countFreeGifts2InCart();
  
  // Get max from a hidden input or use default
  const maxFreeGifts2Input = document.getElementById('max-free-gifts-2');
  const maxFreeGifts2 = maxFreeGifts2Input ? parseInt(maxFreeGifts2Input.value) : 1;
  
  if (currentFreeGifts2 >= maxFreeGifts2) {
    button.disabled = true;
    button.textContent = 'Limit reached';
    return;
  }
  
  // Disable the button to prevent multiple clicks
  button.disabled = true;
  button.textContent = 'Adding...';
  
  // Add the free gift 2 to cart with price 0
  fetch('/cart/add.js', {         
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
      properties: {
        '_free_gift_2': 'true'
      }
    })
  })
  .then(response => response.json())
  .then(data => {
    // Update button text
    button.textContent = 'Added!';
    
    // Get the free gift 2 section
    const freeGiftSlider2 = document.querySelector('.free-gift-slider-2');
    
      // Play confetti animation
      if (window.cartConfetti) {
  
        
        window.cartConfetti.play();
        
        // Update cart immediately - don't wait for animation to complete
        setTimeout(()=>{
        updateCart();
              // Hide the free gift 2 section when gift is added to cart
              if (freeGiftSlider2) {
                freeGiftSlider2.style.display = 'none';
              }
      }, 1400)
      }
  })
  .catch(error => {
    console.error('Error:', error);
    button.disabled = false;
    const addGiftText2Input = document.getElementById('add-gift-text-2');
    const addGiftText2 = addGiftText2Input ? addGiftText2Input.value : 'Add to cart';
    button.textContent = addGiftText2;
  });
}

// Check how many free gifts are already in the cart
function countFreeGiftsInCart() {
  let count = 0;
  
  // If we have cart data in a global variable, use it
  if (window.cartData && window.cartData.items) {
    window.cartData.items.forEach(item => {
      if (item.properties && item.properties._free_gift) {
        count++;
      }
    });
    return count;
  }
  
  // Otherwise, check the DOM for items with the free gift property
  const freeGiftItems = document.querySelectorAll('.elem[data-free-gift="true"]');
  return freeGiftItems.length;
}

// Check how many free gifts 2 are already in the cart
function countFreeGifts2InCart() {
  let count = 0;
  
  // If we have cart data in a global variable, use it
  if (window.cartData && window.cartData.items) {
    window.cartData.items.forEach(item => {
      if (item.properties && item.properties._free_gift_2) {
        count++;
      }
    });
    return count;
  }
  
  // Otherwise, check the DOM for items with the free gift 2 property
  // We need to check the actual cart items via API
  // For now, return 0 and it will be updated when cart is fetched
  return 0;
}

// Update gift buttons based on free gift count
function updateGiftButtons() {
  const maxFreeGiftsEl = document.getElementById('max-free-gifts');
  if (!maxFreeGiftsEl) return;
  
  const maxFreeGifts = parseInt(maxFreeGiftsEl.value);
  const currentFreeGifts = countFreeGiftsInCart();
  const remainingGifts = maxFreeGifts - currentFreeGifts;
  
  const giftButtons = document.querySelectorAll('.add-gift-btn');
  if (giftButtons.length === 0) return;
  
  if (remainingGifts <= 0) {
    // Disable all gift buttons if max is reached
    giftButtons.forEach(button => {
      button.disabled = true;
      button.textContent = 'Limit reached';
    });
  } else {
    // Update button text to show remaining gifts
    giftButtons.forEach(button => {
      if (!button.disabled || button.textContent === 'Limit reached') {
        const addGiftText = document.getElementById('add-gift-text') ? document.getElementById('add-gift-text').value : 'Add to cart';
        button.textContent = addGiftText;
        button.disabled = false;
      }
    });
    
    // Update count message
    const countEl = document.querySelector('.free-gift-count');
    if (countEl && maxFreeGifts > 1) {
      countEl.textContent = '(' + remainingGifts + ' of ' + maxFreeGifts + ' available)';
    }
  }
}

// Update gift 2 buttons based on free gift 2 count
function updateGiftButtons2() {
  const maxFreeGifts2El = document.getElementById('max-free-gifts-2');
  if (!maxFreeGifts2El) return;
  
  const maxFreeGifts2 = parseInt(maxFreeGifts2El.value);
  const currentFreeGifts2 = countFreeGifts2InCart();
  const remainingGifts2 = maxFreeGifts2 - currentFreeGifts2;
  
  const giftButtons2 = document.querySelectorAll('.add-gift-btn-2');
  if (giftButtons2.length === 0) return;
  
  if (remainingGifts2 <= 0) {
    // Disable all gift 2 buttons if max is reached
    giftButtons2.forEach(button => {
      button.disabled = true;
      button.textContent = 'Limit reached';
    });
  } else {
    // Update button text to show remaining gifts
    giftButtons2.forEach(button => {
      if (!button.disabled || button.textContent === 'Limit reached') {
        const addGiftText2 = document.getElementById('add-gift-text-2') ? document.getElementById('add-gift-text-2').value : 'Add to cart';
        button.textContent = addGiftText2;
        button.disabled = false;
      }
    });
    
    // Update count message
    const countEl2 = document.querySelector('.free-gift-count-2');
    if (countEl2 && maxFreeGifts2 > 1) {
      countEl2.textContent = '(' + remainingGifts2 + ' of ' + maxFreeGifts2 + ' available)';
    }
  }
}

// Function to automatically add the first available free gift
function autoAddFreeGift() {
  // Add a 1-second delay before adding the free gift to the cart
  // This ensures the free gift is added at the perfect moment
  setTimeout(() => {
    // Check if we've reached the maximum free gifts
    const maxFreeGifts = parseInt(document.getElementById('max-free-gifts') ? document.getElementById('max-free-gifts').value : 1);
    const currentFreeGifts = countFreeGiftsInCart();
    
    if (currentFreeGifts >= maxFreeGifts) {
      console.log('Maximum free gifts already added');
      return;
    }
    
    // Find the first available free gift button
    const giftButton = document.querySelector('.add-gift-btn:not([disabled])');
    if (giftButton) {
      // Get product and variant IDs
      const productId = giftButton.getAttribute('data-product-id');
      const variantId = giftButton.getAttribute('data-variant-id');
      
      if (!variantId) {
        console.error('No variant ID found for free gift');
        return;
      }
      
      // Add the free gift to cart with price 0
      fetch('/cart/add.js', {         
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: {
            '_free_gift': 'true',
            '_auto_added': 'true'
          }
        })
      })
      .then(response => response.json())
      .then(data => {
        // Update the cart using the existing updateCart function
        updateCart();
        
        // Update button text
        giftButton.textContent = 'Added!';
        giftButton.disabled = true;
        
        console.log('Auto-added free gift:', data.title);
      })
      .catch(error => {
        console.error('Error auto-adding free gift:', error);
      });
    } else {
      console.log('No available free gift buttons found');
    }
  }, 1000); // 1-second delay as requested
}

function initCartFunctionality() {
  // Update quantity inputs in the cart drawer
  initQuantityChanges();
  
  // Initialize remove item buttons
  initRemoveButtons();
  initAddToCartButtonsCart();
}

function initAddToCartButtonsCart() {
  // Find all Add to cart buttons in the new-products-box section
  const addToCartButtons = document.querySelectorAll('.cart__side .box .main__cart .slider__featured .slider__ .inn .desc .bott>a');
  
  addToCartButtons.forEach(button => {
    button.addEventListener('click', function(event) {
      event.preventDefault();
      
      let variantId;
      const productObj = this.dataset.productId;
      
      if (productObj) {
        variantId = this.dataset.variantId;
      } else {
        // Extract variant ID from URL if it's a direct link
        const url = new URL(this.href, window.location.origin);
        const urlParams = new URLSearchParams(url.search);
        variantId = urlParams.get('id');
      }
      
      if (!variantId) {
        console.error('No variant ID found for add to cart');
        return;
      }
      
      // Add the item to the cart
      addToCart(variantId, 1);
    });
  });
}

function initAddToCartButtons() {
  if (document.__hasDelegatedATC) return; // idempotent
  document.__hasDelegatedATC = true;

  document.addEventListener('click', function (event) {
    // Look for a .basket inside the products wrapper
    const btn = event.target.closest('.products__box--wrapper .basket');
    if (!btn) return;

    // Make sure it's really within the wrapper (in case of other .basket elements)
    const wrapper = btn.closest('.products__box--wrapper');
    if (!wrapper) return;

    event.preventDefault();

    let variantId = btn.dataset.variantId || null;

    // Fallback: extract ?id=123 from href if present
    if (!variantId) {
      const href = btn.getAttribute('href');
      if (href) {
        try {
          const url = new URL(href, window.location.origin);
          variantId = url.searchParams.get('id');
        } catch (e) {
          // ignore bad URLs
        }
      }
    }

    if (!variantId) {
      console.error('No variant ID found for add to cart');
      return;
    }

    addToCart(variantId, 1);
  });
}

function initAddToCartButtonsProduct() {
  // Find all Add to cart buttons in the new-products-box section
  const addToCartButtons = document.querySelectorAll('.add-to-cart-button');
  
  addToCartButtons.forEach(button => {
    button.addEventListener('click', function(event) {
      event.preventDefault();
      
      let variantId;
      const productObj = this.dataset.productId;
      
      if (productObj) {
        variantId = this.dataset.variantId;
      } else {
        // Extract variant ID from URL if it's a direct link
        const url = new URL(this.href, window.location.origin);
        const urlParams = new URLSearchParams(url.search);
        variantId = urlParams.get('id');
      }
      
      if(document.querySelectorAll('#product-select[name="id"]').length){
        variantId = document.querySelector('#product-select[name="id"]').value
      }

      if (!variantId) {
        console.error('No variant ID found for add to cart');
        return;
      }
      
      // Add the item to the cart
      addToCart(variantId, 1);
    });
  });
}


function addToCart(variantId, quantity, properties = {}, sellingPlan = null) {
  // Show loading state
  document.body.classList.add('cart-loading');
  
  // Prepare the cart item data
  const cartItem = {
    id: variantId,
    quantity: quantity
  };
  
  // Add properties if provided
  if (Object.keys(properties).length > 0) {
    cartItem.properties = properties;
  }
  
  // Add selling plan if provided
  if (sellingPlan) {
    cartItem.selling_plan = sellingPlan;
  }
  
  // Add item to cart using Shopify's Cart API
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(cartItem)
  })
  .then(response => response.json())
  .then(data => {
    // Successfully added item, now update the cart
    updateCart();
    
    // Check if we should play confetti and add free gift
    fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      }
    })
    .then(response => response.json())
    .then(cart => {
      // Get the gift threshold from the hidden input
      const thresholdInput = document.getElementById('gift-threshold');
      if (!thresholdInput || thresholdInput.dataset.enabled !== 'true') {
        return; // No free gift feature or not enabled
      }
      
      const threshold = parseInt(thresholdInput.value, 10);
      const cartTotal = cart.total_price;
      const currentFreeGifts = countFreeGiftsInCart();
      
      // Only play confetti and add free gift if:
      // 1. Cart total is above threshold
      // 2. No free gifts have been added yet
      // 3. The added item is not a free gift itself (to prevent confetti on free gift add)
      if (cartTotal >= threshold && currentFreeGifts === 0 && !data.properties?._free_gift) {
        console.log('Playing confetti and adding free gift - Cart total:', cartTotal, 'Threshold:', threshold);
        
        // Get the free gift section
        const freeGiftSlider = document.querySelector('.free-gift-slider');
        
        // First hide the free gift section immediately
        if (freeGiftSlider) {
          freeGiftSlider.style.display = 'none';
        }
        
        // Then play confetti animation
        if (window.cartConfetti) {
          //window.cartConfetti.play();
          
          // Add free gift at the very end of the animation
          // This ensures both actions happen simultaneously when confetti is about to fade
          //window.cartConfetti.addFreeGiftAtEnd(freeGiftSlider, autoAddFreeGift);
        }
      } else {
        console.log('Not playing confetti - Cart total:', cartTotal, 'Threshold:', threshold, 'Current free gifts:', currentFreeGifts);
      }
    })
    .catch(error => {
      console.error('Error checking cart for free gift eligibility:', error);
    });
  })
  .catch(error => {
    console.error('Error adding item to cart:', error);
    document.body.classList.remove('cart-loading');
  });
}

function updateCart() {
  // Fetch the updated cart data
  fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Accept': 'application/json'
    }
  })        
  .then(response => response.json())  
  .then(cart => {
    // Store cart data globally for use in other functions
    window.cartData = cart;
    
    // Update cart count
    updateCartCount(cart.item_count);

    // Check if we need to remove free gifts
    // checkAndRemoveFreeGifts will reload cart content if gifts are removed
    // Otherwise, we reload it here
    checkAndRemoveFreeGifts(cart)
      .then(giftsRemoved => {
        // Only reload if gifts were NOT removed (checkAndRemoveFreeGifts already reloaded)
        if (!giftsRemoved) {
          reloadCartContent();
        }
      });
  })
  .catch(error => {
    console.error('Error fetching cart:', error);
    document.body.classList.remove('cart-loading'); 
  });
}

function checkAndRemoveFreeGifts(cart) {
  // Calculate cart total excluding free gift items
  // Free gifts have price 0, but we want to check the total of paid items only
  let cartTotal = 0;
  cart.items.forEach(item => {
    // Only count items that are NOT free gifts
    if (!item.properties || (!item.properties._free_gift && !item.properties._free_gift_2)) {
      cartTotal += item.final_line_price;
    }
  });
  
  // Get the gift 1 threshold from the hidden input
  const thresholdInput = document.getElementById('gift-threshold');
  const gift1Enabled = thresholdInput && thresholdInput.dataset.enabled === 'true';
  const gift1Threshold = gift1Enabled ? parseInt(thresholdInput.value, 10) : null;
  
  // Get the gift 2 threshold from the hidden input
  const thresholdInput2 = document.getElementById('gift-threshold-2');
  const gift2Enabled = thresholdInput2 && thresholdInput2.dataset.enabled === 'true';
  const gift2Threshold = gift2Enabled ? parseInt(thresholdInput2.value, 10) : null;
  
  console.log('Checking free gifts - Cart Total (excluding free gifts):', cartTotal, 'Gift 1 Threshold:', gift1Threshold, 'Gift 2 Threshold:', gift2Threshold);
  
  // Create an updates object for the cart
  const updates = {};
  let hasFreeGiftsToRemove = false;
  let freeGiftCount = 0;
  let freeGift2Count = 0;
  
  // Check gift 1 items - remove if cart total is below gift 1 threshold
  if (gift1Enabled && gift1Threshold !== null && cartTotal < gift1Threshold) {
    console.log('Cart total is below gift 1 threshold, checking for gift 1 items to remove');
    
    cart.items.forEach(item => {
      if (item.properties && item.properties._free_gift) {
        console.log('Found free gift 1 item to remove:', item.title, 'with key:', item.key);
        updates[item.key] = 0; // Set quantity to 0 to remove
        hasFreeGiftsToRemove = true;
        freeGiftCount++;
      }
    });
  }
  
  // Check gift 2 items - remove if cart total is below gift 2 threshold
  if (gift2Enabled && gift2Threshold !== null && cartTotal < gift2Threshold) {
    console.log('Cart total is below gift 2 threshold, checking for gift 2 items to remove');
    
    cart.items.forEach(item => {
      if (item.properties && item.properties._free_gift_2) {
        console.log('Found free gift 2 item to remove:', item.title, 'with key:', item.key);
        updates[item.key] = 0; // Set quantity to 0 to remove
        hasFreeGiftsToRemove = true;
        freeGift2Count++;
      }
    });
  }
  
  console.log('Found', freeGiftCount, 'free gift 1 items and', freeGift2Count, 'free gift 2 items to remove');
  
  // If there are free gifts to remove, remove them all at once
  if (hasFreeGiftsToRemove) {
    console.log('Removing free gifts with updates:', updates);
    
    // Show the free gift sections again when gifts are removed
    if (freeGiftCount > 0) {
      const freeGiftSlider = document.querySelector('.free-gift-slider');
      if (freeGiftSlider) {
        freeGiftSlider.style.display = 'block';
      }
    }
    if (freeGift2Count > 0) {
      const freeGiftSlider2 = document.querySelector('.free-gift-slider-2');
      if (freeGiftSlider2) {
        freeGiftSlider2.style.display = 'block';
      }
    }
    
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ updates })
    })
    .then(response => {
      console.log('Free gift removal response status:', response.status);
      if (!response.ok) {
        throw new Error('Failed to remove free gifts');
      }
      return response.json();
    })
    .then(updatedCart => {
      console.log('Free gifts removed successfully, updated cart:', updatedCart);
      
      // Store updated cart data
      window.cartData = updatedCart;
      
      // Update cart count
      updateCartCount(updatedCart.item_count);
      
      // Reload cart content to reflect the changes
      return reloadCartContent().then(() => true); // Return true to indicate gifts were removed
    })
    .catch(error => {
      console.error('Error removing free gifts:', error);
      // Still reload cart content even if there's an error
      return reloadCartContent().then(() => true);
    });
  } else {
    console.log('Cart total meets thresholds, no need to remove free gifts');
    return Promise.resolve(false); // Return false to indicate no gifts were removed
  }
}

function updateCartCount(count) {
  // Update the cart count in the header
  const cartCountElements = document.querySelectorAll('.cart__open span');
  cartCountElements.forEach(element => {
    if(count == 0){
      element.style.opacity = 0;
    }else{
      element.style.opacity = 1;
    }
    element.textContent = count;
  });
}

function reloadCartContent() {
  // Fetch and update the cart drawer content
  return fetch('/?sections=new-cart-drawer,cart-icon-bubble', {
    method: 'GET'
  })
  .then(response => response.json())
  .then(response => {
    // Parse the HTML and update the cart drawer content
    const parser = new DOMParser();
    const doc = parser.parseFromString(response['new-cart-drawer'], 'text/html');
    console.log(doc.querySelector('.cart__side .box .content'))
    
    // Get the current progress bar percentage before updating (if it exists)
    const currentProgressBar = document.querySelector('.progress-line-fill');
    const currentPercentage = currentProgressBar ? (currentProgressBar.getAttribute('data-progress-percentage') || '0') : '0';
    
    // Get the new progress bar percentage from the parsed HTML
    const newProgressBar = doc.querySelector('.progress-line-fill');
    const newPercentage = newProgressBar ? (newProgressBar.getAttribute('data-progress-percentage') || '0') : '0';
    
    // Show the cart drawer
    const cartSide = document.querySelector('.cart__side');
    if (cartSide) {
      cartSide.style.display = 'block';
      cartSide.querySelector('.box').style.right = '0px';
      cartSide.querySelector('.content').innerHTML = doc.querySelector('.cart__side .box .content').innerHTML;
    }
    
    // Animate progress bar smoothly
    const progressBarFill = document.querySelector('.progress-line-fill');
    if (progressBarFill) {
      // First, set width to current percentage to establish starting point
      progressBarFill.style.width = currentPercentage + '%';
      
      // Force a reflow to ensure the browser recognizes the initial width
      progressBarFill.offsetHeight;
      
      // Use requestAnimationFrame to ensure the DOM is ready, then animate to new width
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          progressBarFill.style.width = newPercentage + '%';
        });
      });
    }
    
    // Initialize cart slider if needed
    initCartSlider();
    
    // Remove loading state
    document.body.classList.remove('cart-loading');
    
    // Initialize the quantity change and remove functionality again
    initCartFunctionality();
    
    // Initialize gift buttons state if they exist
    if (document.querySelector('.add-gift-btn')) {
      updateGiftButtons();
    }
    
    // Initialize gift 2 buttons state if they exist
    if (document.querySelector('.add-gift-btn-2')) {
      updateGiftButtons2();
    }
    
    // Check if there are free gifts in the cart
    const freeGiftItems = document.querySelectorAll('.elem[data-free-gift="true"]');
    const freeGiftSlider = document.querySelector('.free-gift-slider');
    const freeGiftSlider2 = document.querySelector('.free-gift-slider-2');
    
    // Check for free gift 1 items
    let hasFreeGift1 = false;
    if (window.cartData && window.cartData.items) {
      hasFreeGift1 = window.cartData.items.some(item => item.properties && item.properties._free_gift);
    }
    
    // Check for free gift 2 items
    let hasFreeGift2 = false;
    if (window.cartData && window.cartData.items) {
      hasFreeGift2 = window.cartData.items.some(item => item.properties && item.properties._free_gift_2);
    }
    
    // If there are free gifts 1 in the cart, hide the free gift 1 section
    if (hasFreeGift1 && freeGiftSlider) {
      freeGiftSlider.style.display = 'none';
    } else if (freeGiftSlider) {
      // Otherwise, show the free gift 1 section
      freeGiftSlider.style.display = 'block';
    }
    
    // If there are free gifts 2 in the cart, hide the free gift 2 section
    if (hasFreeGift2 && freeGiftSlider2) {
      freeGiftSlider2.style.display = 'none';
    } else if (freeGiftSlider2) {
      // Otherwise, show the free gift 2 section
      freeGiftSlider2.style.display = 'block';
    }
  })
  .catch(error => {
    console.error('Error updating cart content:', error);
    document.body.classList.remove('cart-loading');
  });
}

function initQuantityChanges() {
  // Find all quantity inputs in the cart drawer
  const quantityInputs = document.querySelectorAll('.cart__side .quantity-input');
  
  quantityInputs.forEach(input => {
    // Remove existing event listeners
    const newInput = input.cloneNode(true);
    input.parentNode.replaceChild(newInput, input);
    
    // Add new event listener
    newInput.addEventListener('change', function() {
      const newQuantity = parseInt(this.value, 10);
      
      // Find the closest .elem parent to get the correct line item
      const itemElem = this.closest('.elem');
      
      // Get all visible cart items (including those without quantity selectors)
      const allItems = document.querySelectorAll('.cart__side .products__list .elem');
      
      // Find the index of this item among all items
      const line = Array.from(allItems).indexOf(itemElem) + 1;
      
      console.log('Updating quantity for item at line:', line, 'New quantity:', newQuantity);
      
      updateItemQuantity(line, newQuantity);
    });
  });
}

function updateItemQuantity(line, quantity) {
  // Show loading state
  document.body.classList.add('cart-loading');
  
  console.log('Updating item quantity - Line:', line, 'Quantity:', quantity);
  
  // Update the item quantity
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      line: line,
      quantity: quantity
    })
  })
  .then(response => response.json())
  .then(cart => {
    console.log('Item quantity updated, checking if free gifts should be removed');
    
    // Store cart data globally for use in other functions
    window.cartData = cart;
    
    // Update cart count
    updateCartCount(cart.item_count);
    
    // Update cart subtotal
    updateCartTotals(cart);
    
    // Check if we need to remove free gifts
    checkAndRemoveFreeGifts(cart)
      .then(() => {
        // Reload cart content if quantity is 0 (item removed)
        if (quantity === 0) {
          reloadCartContent();
        } else {
          // Reload cart content anyway to ensure free gift section is updated
          reloadCartContent();
        }
      });
  })
  .catch(error => {
    console.error('Error updating item quantity:', error);
    document.body.classList.remove('cart-loading');
  });
}

function updateCartTotals(cart) {
  // Update subtotal
  const subtotalElements = document.querySelectorAll('.table__result .top .row:first-child p');
  subtotalElements.forEach(element => {
    element.textContent = formatMoney(cart.items_subtotal_price);
  });
  
  // Update total
  const totalElements = document.querySelectorAll('.table__result .bottom p');
  totalElements.forEach(element => {
    element.textContent = formatMoney(cart.total_price);
  });
  
  // Update line item prices
  cart.items.forEach((item, index) => {
    const priceElement = document.querySelectorAll('.cart__side .products__list .elem .desc .bottom p')[index];
    if (priceElement) {
      priceElement.textContent = formatMoney(item.final_line_price);
    }
  });
}

function initRemoveButtons() {
  // Find all remove buttons in the cart drawer
  const removeButtons = document.querySelectorAll('.cart__side .cart-remove');
  
  removeButtons.forEach(button => {
    // Remove existing event listeners
    const newButton = button.cloneNode(true);
    button.parentNode.replaceChild(newButton, button);
    
    // Add new event listener
    newButton.addEventListener('click', function(event) {
      event.preventDefault();
      
      // Find the closest .elem parent to get the correct line item
      const itemElem = this.closest('.elem');
      
      // Get all visible cart items (including those without quantity selectors)
      const allItems = document.querySelectorAll('.cart__side .products__list .elem');
      
      // Find the index of this item among all items
      const line = Array.from(allItems).indexOf(itemElem) + 1;
      
      console.log('Removing item at line:', line);
      
      updateItemQuantity(line, 0);
    });
  });
}

function initCartSlider() {
  // Initialize the featured products slider in the cart drawer
  if (document.querySelector('.slider__featured') && 
      document.querySelector('.slider__featured .slider__') && 
      typeof $.fn.slick !== 'undefined') {
    var width_ = false;
    document.querySelectorAll('.cart__side .box .main__cart .slider__featured .slider__ .slick-list .slick-track').forEach(x=>{
      console.log(x.style.width)
      if(x.style.width == '0px'){
        width_ = true;
      }
    })
    if (!document.querySelector('.slider__featured .slider__').classList.contains('slick-initialized')) {
      $('.slider__featured .slider__').slick({
        slidesToShow: 1,
        dots: false,
        arrows: true
      });
      
      $('.slider__featured .btns>a:nth-child(1)').on("click", function(e) {
        e.preventDefault();
        $('.slider__ .slick-prev').click();
      });
      
      $('.slider__featured .btns>a:nth-child(2)').on("click", function(e) {
        e.preventDefault();
        $('.slider__ .slick-next').click();
      });
    }else if(width_){
      $('.slider__featured .slider__').slick('unslick')
      $('.slider__featured .slider__').slick({
        slidesToShow: 1,
        dots: false,
        arrows: true
      });
      
      $('.slider__featured .btns>a:nth-child(1)').on("click", function(e) {
        e.preventDefault();
        $('.slider__ .slick-prev').click();
      });
      
      $('.slider__featured .btns>a:nth-child(2)').on("click", function(e) {
        e.preventDefault();
        $('.slider__ .slick-next').click();
      });
    }
  }
}

// Helper function to format money
function formatMoney(cents) {
  const formatOptions = {
    style: 'currency',
    currency: Shopify.currency.active || 'USD'
  };
  
  return (cents / 100).toLocaleString(undefined, formatOptions);
}
